import { Stack, Typography, useTheme } from "@mui/material";
import { ScrollWithShadows } from "components/layout/utils/ScrollWithShadows";
import { T } from "components/util/t";
import { useIsMobile } from "hooks/useIsMobile";
import { Sx } from "utils/sx";
import { EVENT_CARD_WIDTH } from "./eventCard/EventCard";
import { Section } from "./HomePage";
import { useRecentOrganisations } from "./useRecentOrganisations";
import { RecentOrganisationCard } from "./RecentOrganisationCard";


const RECENT_ORGANISATION_CARD_WIDTH = 41;
const RECENT_ORGANISATION_CARD_HEIGHT = 12;
const RECENT_ITEM_CARD_SPACING = 1;

const sectionStyle: Sx = (theme) => ({
    marginTop: theme.spacing(6)
});

const recentCardStyle: Sx = (theme) => ({
    width: theme.spacing(RECENT_ORGANISATION_CARD_WIDTH),
    height: theme.spacing(RECENT_ORGANISATION_CARD_HEIGHT),
    [theme.breakpoints.down("md")]: {
        width: theme.spacing(EVENT_CARD_WIDTH)
    }
});

const carouselStyle = (nCards: number): Sx => (theme) => ({
    gap: theme.spacing(RECENT_ITEM_CARD_SPACING),
    paddingX: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
        height: theme.spacing((RECENT_ORGANISATION_CARD_HEIGHT * Math.min(nCards, 2)) + 2),
        flexDirection: "column",
        flexWrap: "wrap"
    }
});

export const RecentOrganisations: React.FC = () => {
    const theme = useTheme();
    const isMobile = useIsMobile();
    const recentOrganisations = useRecentOrganisations();

    if (recentOrganisations.length === 0) return null;

    const cardWidth = parseInt(theme.spacing(isMobile ? EVENT_CARD_WIDTH : RECENT_ORGANISATION_CARD_WIDTH));
    const cardGap = parseInt(theme.spacing(RECENT_ITEM_CARD_SPACING));
    const cardWidthWithGap = cardWidth + cardGap;

    return(
        <Section sx={sectionStyle}>
            <Typography variant="h3" component="h3" sx={(theme) => ({ marginBottom: theme.spacing(2), paddingX: theme.spacing(2) })}>
                <T>Recent organisations</T>
            </Typography>
            <ScrollWithShadows shadowsColor="background.default" showButtons buttonsPositionAbsolute fixedScrollOffset={cardWidthWithGap}>
                <Stack sx={carouselStyle(recentOrganisations.length)} direction="row">
                    {recentOrganisations.map((item, index) =>
                        <RecentOrganisationCard organisation={item} key={index} sx={recentCardStyle} />
                    )}
                </Stack>
            </ScrollWithShadows>
        </Section>
    );
};
